import OnboardingRoutesWithProvider from '@leagueplatform/onboarding';
import { TENANT_ID } from 'common/constants';
import { Box, styled } from '@leagueplatform/genesis-core';
import { getFeatureHighlightsContentfulId } from 'common/env';

const Wrapper = styled(Box, {
  '& [data-testid="GDS-Button"]': {
    borderColor: '#0070C4FF !important',
    borderRadius: '30px !important',
    paddingBlock: '4px',
    paddingInline: '12px',
  },
  '@mobileLandscape': {
    '& [data-testid="GDS-Button"]': {
      backgroundColor: '#FFFFFF',
    },
  },
  '@mobile': {
    '& [data-testid="GDS-Button"]': {
      backgroundColor: '#FFFFFF',
    },
  },
});

export const OnboardingFeatureHighlights = ({
  onOnboardingComplete,
}: {
  onOnboardingComplete: (error?: Error) => void;
}) => (
  <Wrapper>
    <OnboardingRoutesWithProvider
      contentfulId={getFeatureHighlightsContentfulId()}
      tenantId={TENANT_ID}
      onOnboardingComplete={onOnboardingComplete}
    />
  </Wrapper>
);
